import { render, staticRenderFns } from "./EditButtonTabAction.vue?vue&type=template&id=aadd960e&"
import script from "./EditButtonTabAction.vue?vue&type=script&lang=js&"
export * from "./EditButtonTabAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports